var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(_vm.showOverlay)?_c('div',{staticClass:"toast"},[_c('span',{on:{"click":_vm.goToOperations}},[_vm._v(_vm._s(_vm.$t('app.reload_operations')))]),_c('span',{staticClass:"close",on:{"click":_vm.closeToast}},[_vm._v("x")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }